import { render, staticRenderFns } from "./ChangeBenefitDia.vue?vue&type=template&id=508dc4c6&scoped=true"
import script from "./ChangeBenefitDia.vue?vue&type=script&lang=js"
export * from "./ChangeBenefitDia.vue?vue&type=script&lang=js"
import style0 from "./ChangeBenefitDia.vue?vue&type=style&index=0&id=508dc4c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508dc4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('508dc4c6')) {
      api.createRecord('508dc4c6', component.options)
    } else {
      api.reload('508dc4c6', component.options)
    }
    module.hot.accept("./ChangeBenefitDia.vue?vue&type=template&id=508dc4c6&scoped=true", function () {
      api.rerender('508dc4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/ChangeBenefitDia.vue"
export default component.exports